<template>
    <b-container class="container">
        <b-row>
            <h1>{{ heading }}</h1>
        </b-row>
        <b-row>
            <b-col>
                <b-table striped hover stacked="md" :items="items" :fields="fields">
                    <template #cell(wine)="data">
                        {{ data.value.wine }} <small style="color: gray;">{{ data.value.sublabel }}</small>
                    </template>
                </b-table>            
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'wines',
    props: {
        heading: {
            type: String,
            default: "Weine"
        },
        items: {
            type: String
        }
    },
    data() {
        return {
            fields: [
                {
                    key: "nr",
                    label: '#',
                    sortable: true
                },
                {
                    key: "year",
                    label: 'Jahr',
                    sortable: true
                },
                {
                    key: 'wine',
                    label: 'Wein'
                },
                {
                    key: "sweetness",
                    label: 'Restsüße (g/ltr.)',
                    sortable: true, 
                    class: 'text-center',
                    formatter: (value) => {
                        if (value <= 0) {
                            return "-";
                        }

                        return Number(value).toFixed(1).replace('.', ','); 
                    }  
                },
                {
                    key: "glas_01",
                    label: 'Glas 0,1 ltr.',
                    sortable: true,
                    class: 'text-center',
                    formatter: (value) => {
                        if (value <= 0) {
                            return "-";
                        }

                        return Number(value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); 
                    }              
                },
                {
                    key: "glas_025",
                    label: 'Glas 0,25 ltr.',
                    sortable: true,
                    class: 'text-center',
                    formatter: (value) => {
                        if (value <= 0) {
                            return "-";
                        }

                        return Number(value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
                    }    
                },
                {
                    key: "bottle",
                    label: 'Flasche',
                    sortable: true,
                    class: 'text-center',
                    formatter: (value) => {
                        if (value <= 0) {
                            return "-";
                        }

                        return Number(value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
                    }    
                }
            ]
        }
    }
}
</script>

<style scoped style="sass">
    .row {
        margin-top: 0.5em;
    }
</style>
